import {
  RouteMetaContext
} from "../components/Admin/Secure/SecureRoutes/components/RouteMetaContextProvider/RouteMetaContextProvider";
import {useContext} from "react";

export const useCurrentRouteMeta = () => {
  return useContext(RouteMetaContext);
}